module.exports = __webpack_public_path__ + "static/media/12.4465da74.png";